export function stickyHeader() {
  if (!IS_TOUCH) {
    const headerNav = $('#header-nav');
    let targetOffsetTop = '';

    const INIT = () => {
      targetOffsetTop = $('#header-nav-container').offset().top;
    };
    
    INIT();
    $(window).on('load debouncedresize', INIT);

    $(window).on('scroll debouncedresize', function() {
      const scrollTop = $(window).scrollTop();
      if (scrollTop >= targetOffsetTop) {
        headerNav.addClass('is-sticky');
      } else {
        headerNav.removeClass('is-sticky');
      }
    });
  }
};